const mergeLabelValues = (listValue: any, detailValue: any): any[] | undefined => {
  const values = [...(Array.isArray(listValue) ? listValue : []), ...(Array.isArray(detailValue) ? detailValue : [])];
  if (!values.length) return undefined;
  const seen = new Set<string>();
  return values.filter((value) => {
    const key = typeof value === "string" ? value.trim().toLowerCase() : String(value?.name ?? value?.title ?? value?.label ?? value?.value ?? JSON.stringify(value));
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const mergeIssueData = (listIssue: any, details: any): any => {
  const merged = { ...(listIssue && typeof listIssue === "object" ? listIssue : {}), ...(details && typeof details === "object" ? details : {}) };
  ["labels", "labelNames", "label_names", "giteaLabels", "gitea_labels"].forEach((key) => {
    const labels = mergeLabelValues(listIssue?.[key], details?.[key]);
    if (labels) merged[key] = labels;
  });
  return merged;
};

export const resolveIssueKind = (issue: any): "user" | "development" => {
  const types = [issue?.issueType, issue?.issue_type, issue?.issueKind, issue?.issue_kind, issue?.kind, issue?.category, issue?.type];
  if (types.some((value) => typeof value === "string" && ["development", "development issue", "dev", "audit"].includes(value.trim().toLowerCase().replace(/[\s_-]+/g, " ")))) return "development";
  const labels = Array.isArray(issue?.labels) ? issue.labels : [];
  return labels.some((label: any) => ["audit", "development"].includes(String(typeof label === "string" ? label : label?.name || "").trim().toLowerCase())) ? "development" : "user";
};

export const resolveGiteaDrawerClass = (issue: any): string => resolveIssueKind(issue) === "development"
  ? "absolute right-0 top-0 h-full w-full overflow-y-auto border-l border-indigo-100/60 bg-white/95 p-4 shadow-2xl sm:p-6 lg:w-[72vw] lg:max-w-5xl xl:w-[62vw] dark:border-indigo-500/30 dark:bg-slate-950/95"
  : "absolute right-0 top-0 h-full w-full max-w-xl overflow-y-auto border-l border-indigo-100/60 bg-white/95 p-6 shadow-2xl dark:border-indigo-500/30 dark:bg-slate-950/95";

export const resolveIssueTypeDisplay = (issue: any): string | null => {
  if (resolveIssueKind(issue) !== "development") return null;
  const value = [issue?.developmentRole, issue?.actorRole].find((candidate) => typeof candidate === "string" && candidate.trim());
  return value ? value.trim() : null;
};
